import React, { useRef } from 'react';
import cx from 'classnames';
import { setClipboard } from 'utils/clipboard';
import toast from 'components/common/toast';

import CopySVG from './images/copy.svg';

import './index.scss';

interface Cell {
    className?: string;
    title?: string;
    value?: string | React.ReactNode;

    align?: 'left' | 'right';

    children?: React.ReactNode;
    cellClick?: () => void;
    enabledCopy?: boolean; // 显示 Copy Icon，点击会 copy value
}

const Cell: React.FC<Cell> = (props) => {
    const { title, value, align, enabledCopy, cellClick } = props;

    const valueRef = useRef<HTMLDivElement>(null);

    const onCopy = (e: Event) => {
        if (!valueRef.current) {
            return;
        }

        try {
            e.stopPropagation();
            setClipboard(valueRef.current.textContent || '');
            toast('复制成功');
        } catch (err) {
            // Silent
        }
    };

    return (
        <div className={cx('cell', props.className)} onClick={cellClick}>
            {title && <div className="cell__title">{title}</div>}
            {value && (
                <>
                    <div
                        ref={valueRef}
                        className={cx('cell__value', {
                            textRight: align === 'right'
                        })}
                        style={{
                            textAlign: align || 'left'
                        }}
                        onClick={enabledCopy ? onCopy : () => {}}
                    >
                        {value}
                    </div>
                    {enabledCopy && (
                        <div className="cell__copy" onClick={onCopy}>
                            <CopySVG />
                        </div>
                    )}
                </>
            )}
            {props.children && <div className="cell__content">{props.children}</div>}
        </div>
    );
};

export default Cell;
